/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ApplicationListMeta
 */
export interface ApplicationListMeta {
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_ALL?: number
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_STATUS_EXPERTISE?: number
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_STATUS_PAYMENT?: number
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_STATUS_ISSUED?: number
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_STATUS_ON_COMPLETED?: number
  /**
   *
   * @type {number}
   * @memberof ApplicationListMeta
   */
  FILTER_STATUS_SEND_INTO_ROSPATENT?: number
}

/**
 * Check if a given object implements the ApplicationListMeta interface.
 */
export function instanceOfApplicationListMeta(
  value: object
): value is ApplicationListMeta {
  return true
}

export function ApplicationListMetaFromJSON(json: any): ApplicationListMeta {
  return ApplicationListMetaFromJSONTyped(json, false)
}

export function ApplicationListMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationListMeta {
  if (json == null) {
    return json
  }
  return {
    FILTER_ALL: json['FILTER_ALL'] == null ? undefined : json['FILTER_ALL'],
    FILTER_STATUS_EXPERTISE:
      json['FILTER_STATUS_EXPERTISE'] == null
        ? undefined
        : json['FILTER_STATUS_EXPERTISE'],
    FILTER_STATUS_PAYMENT:
      json['FILTER_STATUS_PAYMENT'] == null
        ? undefined
        : json['FILTER_STATUS_PAYMENT'],
    FILTER_STATUS_ISSUED:
      json['FILTER_STATUS_ISSUED'] == null
        ? undefined
        : json['FILTER_STATUS_ISSUED'],
    FILTER_STATUS_ON_COMPLETED:
      json['FILTER_STATUS_ON_COMPLETED'] == null
        ? undefined
        : json['FILTER_STATUS_ON_COMPLETED'],
    FILTER_STATUS_SEND_INTO_ROSPATENT:
      json['FILTER_STATUS_SEND_INTO_ROSPATENT'] == null
        ? undefined
        : json['FILTER_STATUS_SEND_INTO_ROSPATENT'],
  }
}

export function ApplicationListMetaToJSON(
  value?: ApplicationListMeta | null
): any {
  if (value == null) {
    return value
  }
  return {
    FILTER_ALL: value['FILTER_ALL'],
    FILTER_STATUS_EXPERTISE: value['FILTER_STATUS_EXPERTISE'],
    FILTER_STATUS_PAYMENT: value['FILTER_STATUS_PAYMENT'],
    FILTER_STATUS_ISSUED: value['FILTER_STATUS_ISSUED'],
    FILTER_STATUS_ON_COMPLETED: value['FILTER_STATUS_ON_COMPLETED'],
    FILTER_STATUS_SEND_INTO_ROSPATENT:
      value['FILTER_STATUS_SEND_INTO_ROSPATENT'],
  }
}
